module.exports = __webpack_public_path__ + "1ef63e8c4ec0dbe169c3b7f744fad4bf.png";